import YPayLandingPage from '@components/YPay/YPayLandingPage'
import React from 'react'

function Index() {
  return (
    <YPayLandingPage />
  )
}

export default Index